(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dn-choice-finder"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dn-choice-finder')) {
    customElements.define('dn-choice-finder', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized) return;
        this.dataset.initialized = 'true';
        this.tabs = Array.from(this.querySelectorAll('[data-dn-choice]'));
        this.panels = Array.from(this.querySelectorAll('[data-dn-panel]'));
        this.tabs.forEach((tab, index) => {
          tab.tabIndex = tab.getAttribute('aria-selected') === 'true' ? 0 : -1;
          tab.addEventListener('click', () => this.activate(tab.dataset.dnChoice));
          tab.addEventListener('keydown', (event) => {
            if (!['ArrowDown', 'ArrowRight', 'ArrowUp', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
            event.preventDefault();
            const direction = ['ArrowDown', 'ArrowRight'].includes(event.key) ? 1 : -1;
            const next = this.tabs[event.key === 'Home' ? 0 : event.key === 'End' ? this.tabs.length - 1 : (index + direction + this.tabs.length) % this.tabs.length];
            next.focus();
            this.activate(next.dataset.dnChoice);
          });
        });
      }

      activate(id) {
        this.tabs.forEach((tab) => {
          const active = tab.dataset.dnChoice === id;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
        });
        this.panels.forEach((panel) => { panel.hidden = panel.dataset.dnPanel !== id; });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dn-community"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dn-community-count')) {
    customElements.define('dn-community-count', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized) return;
        this.dataset.initialized = 'true';
        const target = Number(this.dataset.target);
        const label = this.querySelector('[data-dn-count]');
        if (!label || !Number.isFinite(target)) return;
        const formatter = new Intl.NumberFormat(document.documentElement.lang || 'fr');
        const show = (value) => { label.textContent = `+${formatter.format(value)}`; };
        show(target);
        if (this.dataset.animate !== 'true' || matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
        this.observer = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.observer.disconnect();
          const start = performance.now();
          const frame = (now) => {
            const progress = Math.min((now - start) / 1400, 1);
            show(Math.round(target * (1 - Math.pow(1 - progress, 3))));
            if (progress < 1 && this.isConnected) this.frame = requestAnimationFrame(frame);
          };
          this.frame = requestAnimationFrame(frame);
        }, { threshold: 0.35 });
        this.observer.observe(this);
      }
      disconnectedCallback() { this.observer?.disconnect(); cancelAnimationFrame(this.frame); delete this.dataset.initialized; }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dn-proof-videos"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('dn-proof-reel')) customElements.define('dn-proof-reel', class extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    const rail = this.querySelector('.dn-proof__grid');
    const cards = Array.from(rail.querySelectorAll('figure'));
    const previous = this.querySelector('[data-dn-prev]');
    const next = this.querySelector('[data-dn-next]');
    const position = this.querySelector('[data-dn-position]');
    if (!cards.length) { previous.disabled = next.disabled = true; position.textContent = '0 / 0'; return; }
    const step = () => cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : cards[0].offsetWidth;
    const move = direction => rail.scrollBy({left: direction * step(), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    const update = () => {
      const index = Math.min(cards.length - 1, Math.round(rail.scrollLeft / Math.max(step(), 1)));
      position.textContent = `${index + 1} / ${cards.length}`;
      previous.disabled = rail.scrollLeft < 2;
      next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 2;
    };
    rail.addEventListener('scroll', update, {passive:true});
    this.resizeObserver = new ResizeObserver(update); this.resizeObserver.observe(rail);
    this.querySelectorAll('video').forEach(video => {
      const play = video.parentElement.querySelector('[data-dn-play]');
      play.hidden = false;
      play.addEventListener('click', () => { video.play().catch(() => { play.hidden = false; }); });
      video.addEventListener('play', () => {
        play.hidden = true;
        this.querySelectorAll('video').forEach(other => { if (other !== video) other.pause(); });
      });
      video.addEventListener('pause', () => { play.hidden = false; });
      video.addEventListener('ended', () => { play.hidden = false; });
    });
    update();
  }
  disconnectedCallback() { this.resizeObserver?.disconnect(); this.initialized = false; }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
(() => {
  const selector = '[data-dn-cart-section]';
  const current = () => document.querySelector(selector);
  if (!current() || window.__dnNativeCartSync) return;
  window.__dnNativeCartSync = true;
  let pending = null;
  const root = window.Shopify?.routes?.root || '/';
  const propertiesKey = (properties) => JSON.stringify(Object.entries(properties || {}).sort(([a], [b]) => a.localeCompare(b)));
  const identify = (row, cart) => {
    const direct = cart.items.find((item) => item.key === row.dataset.dnLineKey);
    if (direct) return direct;
    const properties = propertiesKey(JSON.parse(row.dataset.dnProperties || '{}'));
    const matches = cart.items.filter((item) => String(item.variant_id) === row.dataset.dnVariant
      && propertiesKey(item.properties) === properties
      && String(item.selling_plan_allocation?.selling_plan?.id || '') === row.dataset.dnPlan);
    return matches.length === 1 ? matches[0] : null;
  };
  const request = async (url, options = {}) => {
    const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', ...options });
    if (!response.ok) throw new Error('Cart request failed');
    return response;
  };
  const showMessage = (key) => {
    const element = current();
    const feedback = element?.querySelector('[data-dn-cart-feedback]');
    if (!feedback) return;
    feedback.textContent = element.dataset[key];
    feedback.hidden = false;
    feedback.focus();
  };
  const render = (html) => {
    if (typeof html !== 'string') throw new Error('Missing cart section');
    const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    const previous = current();
    if (!fresh || !previous || fresh.dataset.dnCartSection !== previous.dataset.dnCartSection) throw new Error('Invalid cart section');
    fresh.inert = true;
    fresh.setAttribute('aria-busy', 'true');
    previous.replaceWith(fresh);
  };
  const refresh = async () => {
    const section = current();
    const url = new URL(section.dataset.dnCartUrl, location.origin);
    url.searchParams.set('section_id', section.dataset.dnCartSection);
    url.searchParams.set('_dn_refresh', Date.now());
    render(await (await request(url)).text());
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  };
  const run = (action) => {
    if (pending) return pending;
    const section = current();
    if (!section) return Promise.resolve();
    section.inert = true;
    section.setAttribute('aria-busy', 'true');
    pending = (async () => {
      let message;
      try {
        message = await action();
      } catch {
        message = 'dnCartError';
      } finally {
        const latest = current();
        if (latest) {
          latest.inert = false;
          latest.removeAttribute('aria-busy');
        }
        pending = null;
      }
      if (message) showMessage(message);
    })();
    return pending;
  };
  const change = (row, quantity) => run(async () => {
    if (!Number.isInteger(quantity) || quantity < 0) return;
    const cart = await (await request(`${root}cart.js`)).json();
    const item = identify(row, cart);
    if (!item) {
      await refresh();
      return 'dnCartChanged';
    }
    const section = current();
    const sectionId = section.dataset.dnCartSection;
    const response = await request(`${root}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: item.key, quantity, sections: [sectionId], sections_url: section.dataset.dnCartUrl })
    });
    const updated = await response.json();
    if (updated.sections?.[sectionId]) render(updated.sections[sectionId]);
    else await refresh();
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    if (typeof window.upcartRefreshCart === 'function') Promise.resolve(window.upcartRefreshCart()).catch(() => {});
  });
  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('line-item-quantity a[href]');
    if (!link?.closest(selector)) return;
    const url = new URL(link.href, location.origin);
    if (!url.pathname.endsWith('/cart/change')) return;
    const row = link.closest('[data-dn-line-key]');
    if (!row) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    change(row, Number(url.searchParams.get('quantity')));
  }, true);
  document.addEventListener('change', (event) => {
    const input = event.target;
    if (!input.matches?.('input[data-line-key]') || !input.closest(selector)) return;
    const row = input.closest('[data-dn-line-key]');
    if (!row) return;
    event.stopImmediatePropagation();
    change(row, Number(input.value));
  }, true);
  window.addEventListener('pageshow', () => run(refresh));
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') run(refresh);
  });
  if (document.readyState === 'complete') run(refresh);
})();

  } catch(e) { console.error(e); }
})();
})();
